var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C63.2608 100 75.9785 94.7322 85.3553 85.3553C94.7322 75.9785 100 63.2608 100 50C100 36.7392 94.7322 24.0215 85.3553 14.6447C75.9785 5.26784 63.2608 0 50 0C36.7392 0 24.0215 5.26784 14.6447 14.6447C5.26784 24.0215 0 36.7392 0 50C0 63.2608 5.26784 75.9785 14.6447 85.3553C24.0215 94.7322 36.7392 100 50 100ZM50 25C52.5977 25 54.6875 27.0898 54.6875 29.6875V51.5625C54.6875 54.1602 52.5977 56.25 50 56.25C47.4023 56.25 45.3125 54.1602 45.3125 51.5625V29.6875C45.3125 27.0898 47.4023 25 50 25ZM43.75 68.75C43.75 67.0924 44.4085 65.5027 45.5806 64.3306C46.7527 63.1585 48.3424 62.5 50 62.5C51.6576 62.5 53.2473 63.1585 54.4194 64.3306C55.5915 65.5027 56.25 67.0924 56.25 68.75C56.25 70.4076 55.5915 71.9973 54.4194 73.1694C53.2473 74.3415 51.6576 75 50 75C48.3424 75 46.7527 74.3415 45.5806 73.1694C44.4085 71.9973 43.75 70.4076 43.75 68.75Z",
    fill: "#FF4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleExclamation);
export default __webpack_public_path__ + "static/media/circle-exclamation.adc327c216b00d273c9d1f3ef7d47d1b.svg";
export { ForwardRef as ReactComponent };